import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';

@Component({
  selector: 't4-emoji-picker',
  templateUrl: './emoji-picker.html',
  styleUrls: ['./emoji-picker.css'],
})
export class T4EmojiPickerComponent implements OnInit {

  ngOnInit() {
  }

  @Output() emojiSelected = new EventEmitter<string>();

  onEmojiSelect(event: any): void {
    const emoji = event.emoji?.native ?? event.native ?? '';
    this.emojiSelected.emit(emoji);
    console.log("Emoji!");
  }

}

